import { FC, ChangeEvent } from "react"
import styled from "styled-components"

interface CheckboxProps {
  name: string
  checked: boolean
  value: any
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export const Checkbox: FC<CheckboxProps> = ({
  name,
  checked,
  value,
  onChange,
}) => {
  return (
    <CheckboxContainer>
      <MockInput $checked={checked}>
        <Input
          id={name}
          name={name}
          checked={checked}
          type="checkbox"
          value={value}
          onChange={e => onChange(e)}
        />
        <Checkmark
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 11 8"
        >
          <path
            d="M1.258 4.564l2.23 2.19L9.848.504"
            stroke="#25211E"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </Checkmark>
      </MockInput>
    </CheckboxContainer>
  )
}

const CheckboxContainer = styled.div`
  position: absolute;
  z-index: 1;
  top: 1.2rem;
  left: 1rem;
  display: flex;
  align-items: center;
`

const MockInput = styled.div<{ $checked: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 2rem;
  height: 2rem;

  border: 1px solid ${({ theme }) => theme.color.white};
  background: ${({ theme, $checked }) =>
    $checked ? theme.color.white : "transparent"};
  border-radius: 0.3rem;
`

const Checkmark = styled.svg`
  width: 1rem;
  visibility: hidden;
`

const Input = styled.input`
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  width: 100%;
  height: 100%;

  &:checked {
    border-color: ${({ theme }) => theme.color.black};

    + ${Checkmark} {
      visibility: visible;
    }
  }
`
